var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #d47500;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 133.3;\n        stroke-width: 50px;\n      }\n\n      .st1 {\n        stroke: #336;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612,400h-212M400,400h-212M400,400v-216M400,400v216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.3,111.3c49-28.4,106-44.6,166.7-44.6,184.1,0,333.3,149.2,333.3,333.3s-149.2,333.3-333.3,333.3S66.7,584.1,66.7,400s16.2-117.6,44.6-166.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleSvgrepoCom);
export default __webpack_public_path__ + "static/media/add-circle-svgrepo-com.84c6d08afed9165ef97a07d92b20a25f.svg";
export { ForwardRef as ReactComponent };